/**
 * navCta — lightweight click tracker for the "For Partners" nav experiment.
 *
 * Fire-and-forget. Errors are silently swallowed. Does NOT block navigation.
 * @param {'for_partners'|'list_workspace'|'join_hours'} ctaKey
 */
import api from "./api";

export function trackNavCta(ctaKey) {
  try {
    api.post("/track/nav-cta", {
      cta_key: ctaKey,
      page_source: typeof window !== "undefined" ? window.location.pathname : null,
    }).catch(() => { /* ignore */ });
  } catch { /* ignore */ }
}

export default trackNavCta;
